module.exports = __webpack_public_path__ + "static/media/ENGProjectPrevieww935@1x.0edcc0c3.webp";